import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=fbe49978&scoped=true"
import script from "./CalendarDetail.vue?vue&type=script&lang=js"
export * from "./CalendarDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe49978",
  null
  
)

export default component.exports